export default __webpack_public_path__ + "static/media/Location.af9fa626.svg";